import { Grid, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import dynamic from 'next/dynamic';
import React from 'react';
import BundleImage from '~/assets/download_app_bundle.png';
import FoodImage from '~/assets/download_app_food.png';
import RewardImage from '~/assets/download_app_reward.png';
import Take5 from '~/assets/download_demo_take5.png';
import AppToolBar from '~/components/AppToolBar';
import ImageBox from '~/components/ImageBox.jsx';
import Page from '~/components/Page.jsx';
import Quotes from '~/components/Quotes';
import Callout from '~/components/ui-kit/Callout/Callout';

const DownloadApp = dynamic(() => import('~/components/DownloadApp'), { ssr: false });

const useStyles = makeStyles((theme) => ({
  callouts: {
    backgroundColor: '#f9f6eb',
    paddingTop: 100,
    paddingBottom: 100,
  },
  externalLink: {
    color: 'inherit',
  },
  flexEndImage: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  flexStartImage: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  rewardImageBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  rewardImage: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '0 !important',
    },
  },
  rewardText: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '0 !important',
      marginBottom: 100,

      '& h4': {
        fontSize: '1.5rem',
        position: 'relative',
        top: 8,
      },
    },
  },
  foodImageBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  foodImage: {
    order: 1,
    [theme.breakpoints.down('xs')]: {
      order: 0,
      paddingBottom: '0 !important',
    },
  },
  foodText: {
    order: 0,
    [theme.breakpoints.down('xs')]: {
      order: 1,
      paddingBottom: '0 !important',
      marginBottom: 100,

      '& h4': {
        fontSize: '1.5rem',
        position: 'relative',
        top: 8,
      },
    },
  },
  bundlingImageBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  bundlingImage: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '0 !important',
    },
  },
  bundlingText: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '0 !important',
      marginBottom: 100,

      '& h4': {
        fontSize: '1.5rem',
        position: 'relative',
        top: 8,
      },
    },
  },
  promoImage: {
    [theme.breakpoints.down('md')]: {},
  },
  take5BG: {
    marginTop: 60,
    backgroundColor: theme.palette.primary.main,
  },
}));

function TakeFive() {
  const classes = useStyles();

  return (
    <Grid container className={classes.take5BG} justify='center'>
      <Grid item xs={12} md={8}>
        <ImageBox className={classes.promoImage} fit='cover' src={Take5} />
      </Grid>
    </Grid>
  );
}

function Callouts() {
  const classes = useStyles();

  return (
    <Grid container justify='center' className={classes.callouts}>
      <Grid container item xs={10} md={12} className={classes.whoWeAreContent}>
        <Grid container item spacing={8} justify='center'>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            style={{ maxHeight: 480 }}
            className={classes.rewardImage}>
            <ImageBox
              fit='cover'
              src={RewardImage}
              className={classes.rewardImageBox}
              style={{ width: 'auto' }}
            />
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            justify='center'
            alignItems='center'
            className={classes.rewardText}>
            <Grid item>
              <Callout
                title='Get deals and rewards'
                text='As an app user, you’ll be the ﬁrst to know about new deals. Collect loyalty points from your favorite restaurants and redeem them for rewards.'
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container item spacing={8} justify='center'>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            justify='center'
            alignItems='center'
            className={classes.foodText}>
            <Grid item>
              <Callout
                title='Dish-centric Experience'
                titleBorderColor='#ffdc25'
                text='We partner with restaurants to showcase their most authentic and delicious dishes.'
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            lg={3}
            style={{ maxHeight: 480 }}
            className={classes.foodImage}>
            <ImageBox
              fit='cover'
              src={FoodImage}
              className={classes.foodImageBox}
              style={{ width: 'auto' }}
            />
          </Grid>
        </Grid>
        <Grid container item spacing={8} justify='center'>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            style={{ maxHeight: 480 }}
            className={classes.bundlingImage}>
            <ImageBox
              fit='cover'
              src={BundleImage}
              className={classes.bundlingImageBox}
              style={{ width: 'auto' }}
            />
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={6}
            md={4}
            justify='center'
            alignItems='center'
            className={classes.bundlingText}>
            <Grid item>
              <Callout
                title='Restaurant Bundling'
                titleBorderColor='#15d0c5'
                text='Order from diﬀerent restaurants in a single order with no added fees, letting you sample a wider variety of dishes in one meal.'
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function Download() {
  return (
    <Page name='download' fullWidth>
      <AppToolBar />
      <Grid container justify='center' style={{ marginTop: 60 }}>
        <Grid item xs={10} sm={8}>
          <DownloadApp />
        </Grid>
      </Grid>
      <TakeFive />
      <Callouts />
      <Grid container justify='center' style={{ backgroundColor: '#fdd129', padding: '120px 0' }}>
        <Typography style={{ fontFamily: 'proximanova-bold', fontSize: '1.5rem', marginBottom: 20 }}>
          In the news
        </Typography>
        <Quotes />
      </Grid>
    </Page>
  );
}

export default Download;

export async function getStaticProps() {
  return {
    props: {},
  };
}
